import { ModalPositionType } from '../types';
import { ModalPositionProp } from '../properties/modal-properties';

export function getModalPosition(position?: ModalPositionType) {
  if (!position) {
    return '';
  }
  return ModalPositionProp[position];
}
